import moment from 'moment';
import 'moment-timezone';
import store from '@/store/index';
import { isEmpty } from 'lodash';

export default {
    install(Vue) {
        // SHORTEN ANY STRING
        Vue.filter('shorten', (value, len) => {
            let shortValue = value.toString();
            if (shortValue.length < len) return shortValue;
            shortValue = `${shortValue.substring(0, len)}...`;
            return shortValue;
        });

        // LOWERCASE ANY STRING
        Vue.filter('lowercase', value => {
            if (!value) {
                return '';
            }
            return value.toString().toLowerCase();
        });

        // UPPERCASE ANY STRING
        Vue.filter('uppercase', value => {
            if (!value) return '';
            return value.toString().toUpperCase();
        });

        // CAPITALIZE ANY STRING
        Vue.filter('capitalize', value => {
            if (!value) return '';
            const str = value.toString();
            return str.charAt(0).toUpperCase() + str.slice(1);
        });

        // TRIM WHITESPACE
        Vue.filter('trim', value => value.trim());

        // FORMAT DATE
        Vue.filter('formatDate', (value, format = 'L', lang = store.getters.lang) => {
            if (!value) return '';
            const tz = !isEmpty(store.getters.site) ? store.getters.site?.tz : moment.tz.guess();
            const mom = typeof value === 'object' ? moment(value).tz(tz) : moment(String(value)).tz(tz);
            // sp date format has priority over user lang
            const locale = store.getters.teamDateFormat || lang;
            return mom.locale(locale).format(format);
        });

        // TOFIXED
        Vue.filter('toFixed', (value, number) => {
            if (typeof value !== 'number' || Number.isNaN(value)) {
                return '0'.toFixed(number);
            }
            return value.toFixed(number);
        });
    },
};
